document.addEventListener('DOMContentLoaded', function () {
  const openBtn = document.getElementById('notify-open');
  const closeBtn = document.getElementById('notify-close');
  const popup = document.getElementById('notify-popup');
  const form = document.getElementById('notify-form');

  if (!openBtn || !closeBtn || !popup) return;

  function closePopup() {
    popup.classList.remove('active');

    setTimeout(() => {
      popup.style.display = 'none';
      document.body.style.overflow = '';
    }, 450);
  }

  openBtn.addEventListener('click', function () {
    popup.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    requestAnimationFrame(() => {
      popup.classList.add('active');
    });
  });

  closeBtn.addEventListener('click', closePopup);

  popup.addEventListener('click', function (event) {
    if (event.target === popup) {
      closePopup();
    }
  });

  if (!form) return;

  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    const email = form.querySelector('[name="email"]').value;
    const product = form.querySelector('[name="product"]').value;
    const variant = form.querySelector('[name="variant"]').value;
    const productUrl = form.querySelector('[name="product_url"]').value;

    const payload = {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email,
                properties: {
                  waitlist_product: product,
                  waitlist_variant: variant,
                  waitlist_url: productUrl
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: "VJdKmg"
            }
          }
        }
      }
    };

    try {
      await fetch(
        'https://a.klaviyo.com/client/subscriptions/?company_id=W7BYxV',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'revision': '2024-02-15'
          },
          body: JSON.stringify(payload)
        }
      );

      form.innerHTML = `
        <div class="notify-success">
          <div class="notify-success-icon">✓</div>
          <h3>YOU’RE ON THE LIST</h3>
          <p>We’ll notify you as soon as this item becomes available again.</p>
        </div>
      `;

      document.querySelector('.notify-title')?.style.setProperty('display', 'none');
      document.querySelector('.notify-copy')?.style.setProperty('display', 'none');
      document.querySelector('.notify-icon')?.style.setProperty('display', 'none');

      setTimeout(closePopup, 5000);
    } catch (error) {
      console.error(error);
    }
  });
});